import { render, staticRenderFns } from "./PersonalityQuiz.vue?vue&type=template&id=13546fc6&scoped=true&"
import script from "./PersonalityQuiz.vue?vue&type=script&lang=js&"
export * from "./PersonalityQuiz.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityQuiz.vue?vue&type=style&index=0&id=13546fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13546fc6",
  null
  
)

export default component.exports